// For miscelaneous components
import {useNavigate } from 'react-router-dom'
import logo from '../assets/tfg_logo.png'

// Header Component for all pages
// *  remove_link removes the ability to navigate to the main menu
// *  print_show removes this component from appearing in the print menu
// used for the onboarding page
export function Header({ remove_link = false, print_show = true }: { remove_link?: boolean, print_show?: boolean }) {
  const navigate = useNavigate()
  
  const handle_click = () => {
    if (!remove_link) {
      navigate('/main_menu')
    }
  }

  return(
    <header className={`w-full h-32 relative ${print_show ? '' : 'print:hidden'}`}>

      <ColoredTop />

      <DevModeTag />

      <img src={logo} alt='Trinity MEP Logo' className={`relative h-24 top-5 left-5 ${remove_link ? 'cursor-default' : 'cursor-pointer'} dark:bg-stone-100 rounded-lg p-2`} onClick={handle_click}/>

    </header>
  )
}

export function Logo({ remove_link = false }: { remove_link?: boolean }) {
  const navigate = useNavigate()

  const handle_click = () => {
    navigate('/main_menu')
  }

  return (
    <img src={logo} alt='Trinity MEP Logo' className={` ${remove_link ? 'cursor-default' : 'cursor-pointer'} dark:bg-stone-100 rounded-lg p-2`} onClick={remove_link ? undefined : handle_click}/>
  )
}

// Shows the Dev Mode in website in dev env
export function DevModeTag() {
  const check_dev_mode = () => {
    return process.env.NODE_ENV === "development"
  }
  return(
    <>
      {check_dev_mode() && <h3 className='absolute p-2 text-2xl font-bold text-center text-green-500 bg-gray-100 rounded-lg top-5 right-5 md:right-5'>DEV MODE</h3>}
    </>
  )
}

// Shows the colored line in the website
export function ColoredTop() {
  return (
    <div className='w-full h-1 bg-gradient-to-r from-red-400 to-blue-400 dark:from-red-800 dark:to-blue-800 -z-10 md:h-4' />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function Error_Component({ errorString }: { errorString: string }) {
  return (
      <div className="justify-center p-5 mx-auto bg-red-500">
          <p className="text-white">{errorString}</p>
      </div>
  )
}

/**
 * This function handles the api method at the end of the form
 * 
 * It takes in two functions, one for the POST method and one for the PUT method
 * 
 * It returns the function that corresponds to the method (Either POST or PUT)
 * 
 * @param create_fn corresponds to the POST method
 * @param edit_fn corresponds to the PUT method
 * 
 * @returns An API call function from their respective files
 */

export function MethodHandler(method: "POST" | "PUT" , create_fn: Function, update_fn: Function): Function {
  if (method === "POST"){
      return create_fn
  }
  else if (method === "PUT"){
      return update_fn
  } 
  throw new Error("Invalid method: Received " + method)
}

export function Divider() {
  return <div className="h-[2px] my-1 bg-gradient-to-r from-red-200 from-0% via-red-300 via-20% to-transparent to-80% rounded-lg dark:from-stone-400 dark:via-stone-600 dark:to-transparent" />
}

// Function that opens a folder in the file explorer
// Requires the LocalExplorer extension to be installed and it's software to be running
// The `folder_path` is the path should include the year and project name
export const openFolder = (folder_path: string, drive: string = "T") => {
    if (folder_path) {
        const new_folder_path = `localexplorer:${drive}:/${folder_path}`

        window.open(new_folder_path, "_blank")
    }
}
